export default "__VITE_ASSET__BiJzkjBV__"